import AuthService from "../services/auth.service";

const menu = JSON.parse(localStorage.getItem('menu'));

const estadoInicial = menu
  ? { status: { loggedIn: true }, menu }
  : { status: { loggedIn: false }, menu: null };

export const auth = {
  namespaced: true,
  state: estadoInicial,
  actions: {
    login({ commit }, menu) {
      return AuthService.login(menu).then(
        menu => {
          commit('loginSuccess', menu);
          return Promise.resolve(menu);
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    logout({ commit }) {
      AuthService.logout();
      commit('logout');
    },
  },
  mutations: {
    loginSuccess(state, menu) {
      state.status.loggedIn = true;
      state.menu = menu;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.menu = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.menu = null;
    }
  }
};
